import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";
import { Row, Col, Card, Table, Spinner } from 'react-bootstrap';
import { CloudDownload } from 'react-bootstrap-icons';
import { parseAsMoment } from './../../../shared/utils/date'
import { downloadCsv } from './../../../shared/utils/csv'

/**
 * 保守期限超過ライセンス一覧カード
 *
 * props:
 *  - loading: boolean
 *  - licences: { id, userId, username, licenceKey, maintenanceDate, overdueDays }[]
 *  - limit: number (表示件数上限)
 */
const ExpiredLicencesCard = ({
  loading = false,
  licences = [],
  limit = 10,
}) => {
  const list = licences.slice(0, limit);

  const hasData = Array.isArray(licences) && licences.length > 0;

  // ユーザ詳細ページへのリンク情報
  const goUserPage = (argUser) => ({
    pathname: `/user/${argUser}`
  });
  
  // ライセンス詳細ページへのリンク情報
  const goLicencePage = (argLicence, argUser) => ({
    pathname: `/licence/${argLicence}`,
    state: { userId: argUser },
  });

  const parseData = (arg) => {
    return parseAsMoment(arg).format('YYYY年MM月DD日')
  }

  // CSV出力ハンドラ（※全件を対象にするなら licences を使う）
  const handleExportCsv = () => {
    if (!hasData) return;

    const headers = [
      'ユーザID',
      'ユーザ名',
      'ライセンスID',
      '保守期限',
      '超過日数',
    ];

    const rows = licences.map((lic) => [
      lic.userId || '',
      lic.username || '',
      lic.licenceKey || '',
      lic.maintenanceDate ? parseData(lic.maintenanceDate) : '',
      lic.overdueDays || '',
    ]);

    downloadCsv('expired_licences.csv', headers, rows);
  };

  return (
    <Card>
      <Card.Header>
        <Row>
          <Col sm={12} md={8}>
            保守期限超過ライセンス
            {/* <span className="ms-2 small text-muted"></span> */}
          （保守期限ベース／合計 {licences.length} 件・表示 {limit} 件）
          </Col>
          <Col sm={12} md={4} className="d-flex align-items-center justify-content-end">
            {/* <CloudDownload style={{cursor: 'pointer'}} color="gray" size={16} onClick={handleExportCsv} disabled={loading || !hasData} /> */}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="p-2">
        {loading ? (
          <div className="text-center py-3">
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
          </div>
        ) : (
          <Table size="sm" hover responsive className="text-nowrap">
            <thead>
              <tr>
                <th>ユーザ名</th>
                <th>ライセンスID</th>
                <th>保守期限</th>
                <th>超過日数</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    データがありません
                  </td>
                </tr>
              ) : (
                list.map((lic) => (
                  <tr key={lic.id}>
                    <td>
                      <Link 
                        to={goUserPage(lic.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {lic.username}
                      </Link>{' '}
                    </td>
                    <td>
                      <Link 
                        to={goLicencePage(lic.id, lic.userId)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {lic.licenceKey}
                      </Link>{' '}
                    </td>
                    <td>
                      {lic.maintenanceDate ? parseData(lic.maintenanceDate) : ''}
                    </td>
                    <td className="text-end">{lic.overdueDays}日{' '}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default ExpiredLicencesCard;
